import { useState } from 'react';
import '../../styles/SignInUp.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../ToastContext';

function ContactForm() {
    const API_URL = process.env.REACT_APP_API_URL;
    
    const { showToast } = useToast();

    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');

    const handleMailReport = async (e) => {
        e.preventDefault();

        const response = await axios.post(`${API_URL}/users/problem-report`, { email, subject, body })
        if (response.data) {
            setEmail('');
            setSubject('');
            setBody('');
            showToast("Zgłoszenie zostało wysłane", "success")
            navigate("/");

        } else {
            showToast("Wystąpił błąd, spróbuj ponownie.", "error")
        }
    }


    return (
        <div className="register-wrapper">
            <div className="register-card">
                <h2 className="register-title">
                    TRADI<span className="logo-highlight">WORLD</span>
                </h2>
                <p className="register-subtitle">Formularz zgłoszeniowy</p>

                <form onSubmit={handleMailReport} method='POST' className="register-form">
                    <div className="input-group">
                        <label htmlFor="email">Podaj swój adres e-mail (OPCJONALNE)</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="twoj@email.com"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="subject">Podaj temat problemu</label>
                        <input
                            type="text"
                            id="subject"
                            name="subject"
                            placeholder="Temat zgłoszenia"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="body">Opisz problem</label>
                        <textarea
                            id="body"
                            name="body"
                            placeholder="Opisz dokładnie swój problem..."
                            onChange={(e) => setBody(e.target.value)}
                            rows={5}
                            required
                        />
                    </div>


                    <button type="submit" className="register-button">
                        Wyślij zgłoszenie
                    </button>
                </form>
            </div>
        </div>
    );
}

export default ContactForm;